import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { FilterContext } from 'Components/Filter/context'
import { SearchContext } from 'Components/Layout/MainLayout/SearchContext'
import SearchField from 'Components/SearchComponents/SearchField'
import React, { useContext } from 'react'

const SearchForm = ({ inputStyle, variant = 'h1', fullWith = false }) => {
  const { onSearch } = useContext(FilterContext)
  const { search } = useContext(SearchContext)

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(5),
        width: fullWith ? '100%' : '60%',
      })}
    >
      <Typography
        variant={variant}
        color="text.primary"
      >
        Search
      </Typography>
      <SearchField
        value={search}
        onChange={onSearch}
        allowClear
        style={{ backdropFilter: 'blur(20px)', ...inputStyle }}
      />
    </Box>
  )
}

export default SearchForm
